import React from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import SEO from "../../../components/seo/SEO";
import SeoOutboundLinks from "./../seoOutbondLinks/SeoOutboundLinks";
import SeoHeroBlock from "./SeoHeroBlock";
import SeoToolCard from "./SeoToolCard";
import SeoBottomBlock from "./SeoBottomBlock";

const ToolSeoPageTemplate = ({
                                 seo,
                                 lang,
                                 pageKey,
                                 hero,
                                 blocks,
                                 tool,
                                 pageStyle,
                                 containerFluid = true,
                             }) => {
    const wrapperStyle = pageStyle || {
        background: "linear-gradient(to right, #f8f9fa, #d4edda)",
        border: "1px solid #dee2e6",
        borderRadius: ".2rem",
        marginTop: "-25px",
        marginBottom: "-25px",
    };

    return (
        <>
            <SEO {...seo} />

            <div style={wrapperStyle}>
                <Container fluid={containerFluid} style={{ overflowX: "hidden" }} className="mb-2">
                    <Row className="justify-content-center mt-3 mb-2">
                        <Col xs={12} md={10} lg={10}>

                            <SeoHeroBlock
                                hero={hero}
                                topLinks={
                                    <SeoOutboundLinks
                                        lang={lang}
                                        pageKey={pageKey}
                                        placement="top"
                                    />
                                }
                            />
                        </Col>
                    </Row>

                    <Row className="justify-content-center mt-0">
                        <Col xs={12} md={10} lg={10}>
                            <SeoToolCard>
                                {tool}
                            </SeoToolCard>
                        </Col>
                    </Row>

                    <Row className="justify-content-center mt-0">
                        <Col xs={12} md={10} lg={10}>
                            <Card className="shadow-sm rounded mt-2 p-3">
                            <SeoOutboundLinks
                                lang={lang}
                                pageKey={pageKey}
                                placement="bottom"
                            />
                            </Card>
                        </Col>
                    </Row>
                    <Row className="justify-content-center mt-2 mb-2">
                        <Col xs={12} md={10} lg={10}>
                            <SeoBottomBlock
                                blocks={blocks}
                            />
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
};

export default ToolSeoPageTemplate;
